import About from "../components/Home/About";
import Gallery from "../components/Home/Gallery";
import Hero from "../components/Home/Hero";
import Services from "../components/Home/Services";
import Stats from "../components/Home/State";
import ProcessSteps from "../components/Home/Steps";

function Home() {
  return (
    <div className="App bg-gray-950 text-white overflow-hidden">
      
      <Hero />
      <Stats/>
      <About />
      {/* <Slider/> */}
      <Services />
        <ProcessSteps/>
        <Gallery/>
      {/* <Projects /> */}
      {/* <Testimonials/> */}
      {/* <Contact /> */}
    </div>
  );
}

export default Home;